import { emptys } from "../data/main";

export const writeTax = (value: string | number, label: string | null = null) =>
  `${label ? label + ": " : ""}${emptys.includes(value as string) ? 0 : value}%`;
